__turbopack_context__.v({
  "button": "PhilantropicTeaser-module-scss-module__VTm53q__button",
  "container": "PhilantropicTeaser-module-scss-module__VTm53q__container",
  "description": "PhilantropicTeaser-module-scss-module__VTm53q__description",
  "people": "PhilantropicTeaser-module-scss-module__VTm53q__people",
});
